import isPropValidFromEmotion from "@emotion/is-prop-valid";

export const isPropValidEmotion = isPropValidFromEmotion;

export const isPropValid = (v: string) => !v.startsWith("$");
